<template>
  <router-view/>
</template>

<style lang="scss">
//img {
//    filter: grayscale(100%);
//}
.content{
    padding: 10px;
    text-indent: 20pt;
    line-height: 20pt;
    border-top-right-radius: 1em;
    border-top-left-radius: 1em;
    background-color: white;
  }
  
  .main{
        margin-left: 10vw;
        margin-right: 10vw;
        margin-top: 10px;
    }
    body{
      margin: 0;
    }
</style>
<script lang="ts" setup>
import { debounce } from "lodash";

const _ = (window as any).ResizeObserver;
(window as any).ResizeObserver = class ResizeObserver extends _ {
  constructor(callback: (...args: any[]) => void) {
    callback = debounce(callback, 100);
    super(callback);
  }
};
</script>

